export const UPDATE_REPERTOIRE = 'UPDATE_REPERTOIRE';

// GET ONE
export const GET_REPERTOIRE_REQUEST = 'GET_REPERTOIRE_REQUEST';
export const GET_REPERTOIRE_SUCCESS = 'GET_REPERTOIRE_SUCCESS';
export const GET_REPERTOIRE_FAIL = 'GET_REPERTOIRE_FAIL';

// GET ALL
export const GET_ALL_REPERTOIRES_REQUEST = 'GET_ALL_REPERTOIRES_REQUEST';
export const GET_ALL_REPERTOIRES_SUCCESS = 'GET_ALL_REPERTOIRES_SUCCESS';
export const GET_ALL_REPERTOIRES_FAIL = 'GET_ALL_REPERTOIRES_FAIL';

// GET TREE
export const GET_REPERTOIRE_TREE_REQUEST = 'GET_REPERTOIRE_TREE_REQUEST';
export const GET_REPERTOIRE_TREE_SUCCESS = 'GET_REPERTOIRE_TREE_SUCCESS';
export const GET_REPERTOIRE_TREE_FAIL = 'GET_REPERTOIRE_TREE_FAIL';

// GET AUTHORIZED TREE
export const GET_AUTHORIZED_REPERTOIRE_TREE_REQUEST = 'GET_AUTHORIZED_REPERTOIRE_TREE_REQUEST';
export const GET_AUTHORIZED_REPERTOIRE_TREE_SUCCESS = 'GET_AUTHORIZED_REPERTOIRE_TREE_SUCCESS';
export const GET_AUTHORIZED_REPERTOIRE_TREE_FAIL = 'GET_AUTHORIZED_REPERTOIRE_TREE_FAIL';

// GET BY STATUS
export const GET_REPERTOIRES_BY_STATUS_REQUEST = 'GET_REPERTOIRES_BY_STATUS_REQUEST';
export const GET_REPERTOIRES_BY_STATUS_SUCCESS = 'GET_REPERTOIRES_BY_STATUS_SUCCESS';
export const GET_REPERTOIRES_BY_STATUS_FAIL = 'GET_REPERTOIRES_BY_STATUS_FAIL';

// CREATE
export const CREATE_REPERTOIRE_REQUEST = 'CREATE_REPERTOIRE_REQUEST';
export const CREATE_REPERTOIRE_SUCCESS = 'CREATE_REPERTOIRE_SUCCESS';
export const CREATE_REPERTOIRE_FAIL = 'CREATE_REPERTOIRE_FAIL';

// UPDATE
export const UPDATE_REPERTOIRE_REQUEST = 'UPDATE_REPERTOIRE_REQUEST';
export const UPDATE_REPERTOIRE_SUCCESS = 'UPDATE_REPERTOIRE_SUCCESS';
export const UPDATE_REPERTOIRE_FAIL = 'UPDATE_REPERTOIRE_FAIL';

// CHANGE STATUS
export const CHANGE_REPERTOIRE_STATUS_REQUEST = 'CHANGE_REPERTOIRE_STATUS_REQUEST';
export const CHANGE_REPERTOIRE_STATUS_SUCCESS = 'CHANGE_REPERTOIRE_STATUS_SUCCESS';
export const CHANGE_REPERTOIRE_STATUS_FAIL = 'CHANGE_REPERTOIRE_STATUS_FAIL';

// DELETE
export const DELETE_REPERTOIRE_REQUEST = 'DELETE_REPERTOIRE_REQUEST';
export const DELETE_REPERTOIRE_SUCCESS = 'DELETE_REPERTOIRE_SUCCESS';
export const DELETE_REPERTOIRE_FAIL = 'DELETE_REPERTOIRE_FAIL';

// LOADING
export const SET_REPERTOIRE_LOADING = 'SET_REPERTOIRE_LOADING';

// CLEAR
export const CLEAR_REPERTOIRE_MESSAGE = 'CLEAR_REPERTOIRE_MESSAGE';
export const CLEAR_REPERTOIRE_ERROR = 'CLEAR_REPERTOIRE_ERROR';

export const updateRepertoire = (repertoire) => ({
    type: UPDATE_REPERTOIRE,
    repertoire
});

export const getRepertoireRequest = (id) => ({
    type: GET_REPERTOIRE_REQUEST,
    payload: { id }
});

export const getRepertoireSuccess = (repertoire) => ({
    type: GET_REPERTOIRE_SUCCESS,
    payload: repertoire
});

export const getRepertoireFail = (error) => ({
    type: GET_REPERTOIRE_FAIL,
    error
});

export const getAllRepertoiresRequest = () => ({
    type: GET_ALL_REPERTOIRES_REQUEST
});

export const getAllRepertoiresSuccess = (repertoires) => ({
    type: GET_ALL_REPERTOIRES_SUCCESS,
    payload: repertoires
});

export const getAllRepertoiresFail = (error) => ({
    type: GET_ALL_REPERTOIRES_FAIL,
    error
});

export const getRepertoireTreeRequest = () => ({
    type: GET_REPERTOIRE_TREE_REQUEST
});

export const getRepertoireTreeSuccess = (tree) => ({
    type: GET_REPERTOIRE_TREE_SUCCESS,
    payload: tree
});

export const getRepertoireTreeFail = (error) => ({
    type: GET_REPERTOIRE_TREE_FAIL,
    error
});

export const getAuthorizedRepertoireTreeRequest = () => ({
    type: GET_AUTHORIZED_REPERTOIRE_TREE_REQUEST
});

export const getAuthorizedRepertoireTreeSuccess = (tree) => ({
    type: GET_AUTHORIZED_REPERTOIRE_TREE_SUCCESS,
    payload: tree
});

export const getAuthorizedRepertoireTreeFail = (error) => ({
    type: GET_AUTHORIZED_REPERTOIRE_TREE_FAIL,
    error
});

export const getRepertoiresByStatusRequest = (status) => ({
    type: GET_REPERTOIRES_BY_STATUS_REQUEST,
    payload: { status }
});

export const getRepertoiresByStatusSuccess = (repertoires) => ({
    type: GET_REPERTOIRES_BY_STATUS_SUCCESS,
    payload: repertoires
});

export const getRepertoiresByStatusFail = (error) => ({
    type: GET_REPERTOIRES_BY_STATUS_FAIL,
    error
});

export const createRepertoireRequest = (data) => ({
    type: CREATE_REPERTOIRE_REQUEST,
    payload: data
});

export const createRepertoireSuccess = (repertoire) => ({
    type: CREATE_REPERTOIRE_SUCCESS,
    payload: repertoire
});

export const createRepertoireFail = (error) => ({
    type: CREATE_REPERTOIRE_FAIL,
    error
});

export const updateRepertoireRequest = (id, data) => ({
    type: UPDATE_REPERTOIRE_REQUEST,
    payload: { id, data }
});

export const updateRepertoireSuccess = (repertoire) => ({
    type: UPDATE_REPERTOIRE_SUCCESS,
    payload: repertoire
});

export const updateRepertoireFail = (error) => ({
    type: UPDATE_REPERTOIRE_FAIL,
    error
});

export const changeRepertoireStatusRequest = (id, status) => ({
    type: CHANGE_REPERTOIRE_STATUS_REQUEST,
    payload: { id, status }
});

export const changeRepertoireStatusSuccess = (repertoire) => ({
    type: CHANGE_REPERTOIRE_STATUS_SUCCESS,
    payload: repertoire
});

export const changeRepertoireStatusFail = (error) => ({
    type: CHANGE_REPERTOIRE_STATUS_FAIL,
    error
});

export const deleteRepertoireRequest = (id) => ({
    type: DELETE_REPERTOIRE_REQUEST,
    payload: { id }
});

export const deleteRepertoireSuccess = (id) => ({
    type: DELETE_REPERTOIRE_SUCCESS,
    payload: { id }
});

export const deleteRepertoireFail = (error) => ({
    type: DELETE_REPERTOIRE_FAIL,
    error
});

export const setRepertoireLoading = (loading) => ({
    type: SET_REPERTOIRE_LOADING,
    payload: loading
});

export const clearRepertoireMessage = () => ({
    type: CLEAR_REPERTOIRE_MESSAGE
});

export const clearRepertoireError = () => ({
    type: CLEAR_REPERTOIRE_ERROR
});